'use strict';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {CurationEditorAbstract} from '../curation-editor-abstract';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {WorkflowBarActionsCreatorService} from '@ispm/shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import * as _ from 'lodash';
import {PanelsService} from "@ispm/layout/services/panels.service";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {TranslateService} from "@ngx-translate/core";
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {DiagnosticOrderService} from '@ispm/dashboard/test/services/diagnostic-order.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {NotesService} from '@ispm/user/services/notes.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-curation-editor-clinical-trial',
  templateUrl: './curation-editor-clinical-trial.component.html',
  styleUrls: ['./curation-editor-clinical-trial.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationEditorClinicalTrialComponent extends CurationEditorAbstract {
  public formName: string;
  public pwsFormName: string;

  constructor(authService:AuthenticationService,
              formHandler: FormHandlerService,
              public notificationMessageService: NotificationMessageService,
              workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
              modalLoader: DynamicModalLoaderService,
              activatedRoute: ActivatedRoute,
              panelService: PanelsService,
              curationActionCreatorService: CurationActionCreatorService,
              translateService: TranslateService,
              protected diagnosticOrderService : DiagnosticOrderService,
              notesService: NotesService,
              coreAC: CoreActionCreatorService,
              detector: ChangeDetectorRef,
              public userActionCreatorService: UserActionCreatorService,
              public activityService: ActivityService,
              workflowConfigService: WorkflowConfigService,
              _http: HttpInterceptorService,
              router: Router,
              routerManagerService: RouterManagerService) {
    super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader,
      activatedRoute, panelService, notesService, coreAC, curationActionCreatorService, translateService,
      diagnosticOrderService, userActionCreatorService, activityService, _http,router, undefined, detector, workflowConfigService, routerManagerService);
  }

  setInitParams() {
    this.formName = _.get(this.conf, 'ui.forms.editorForms.details.name');
    this.pwsFormName = _.get(this.conf, 'ui.forms.editorForms.placement.name');
  }

  postGetCurationItem() {
    this.isDataLoaded = true;
  }
  postUpdateCurationItem() {
    this.updateForm(this.curationItem.curationData['content']);
  }

  public getCurationKey(): string {
    return _.get(this.curationItem.curationData, 'content.shortTitle') || _.get(this.curationItem.curationData, 'content.vendorData.shortTitle');
  }

  updateForm(form) {
    if (form) {
      for (const prop in form) {
        this.curationItem.curationData['content'][prop] = form[prop];
      }
      this.curationKey = this.getCurationKey();
    }
  }

  validationEvent(valid) {
    this.isValid = valid;
  }

  deleteItem($event) {
    // remove deleted element from validation
    this.validationFormsMap.delete($event.key);
    this.calculateValidationState();
  }

  private calculateValidationState() {
    let valid: boolean = true;
    this.validationFormsMap.forEach((value: boolean, key: string) => {
      if (value == false) {
        valid = false;
      }
    });
    this.isValid = valid;
    this.calculateState();
  }
}
